/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_EmailsInputs */

const en_nav_emails = /** @type {(inputs: Nav_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emails`)
};

/**
* | output |
* | --- |
* | "Emails" |
*
* @param {Nav_EmailsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_emails = /** @type {((inputs?: Nav_EmailsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_EmailsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_emails(inputs)
});